/****************************************************************************************************************************************************************
The attr("srcbg") value is where the background image is stored;
*************************************************************************************************************************************************************/


(function($) {
    document.body.style.backgroundColor = "#12180B"; /* mostly for footer footer */

    $.fn.timeline = function() {
        var selectors = {
            id: $(this),
            item: $(this).find(".timeline-item"),
            activeClass: "timeline-item--active",
            img: ".timeline__img"
        };
        selectors.item.eq(0).addClass(selectors.activeClass);
        selectors.id.css(
            "background-image",
            "url(" +
            selectors.item
            .first()
            .find(selectors.img)
            .attr("srcbg") +
            ")"
        );
        var itemLength = selectors.item.length; // this is the # of items in the timeline

        // do this once the window is scrolled
        $(window).scroll(function() {

            var max, min;
            var pos = $(this).scrollTop(); /* at the top of the page on first scroll this will be 0 */
            var top_offset = $(this).height() / 3; // alphabb: so scrolling is relative to bottom of header, NOT top of page; set to 200 if using the sticky navigation, otherwise 0

            /*
            if(pos <= 10) {
                setHeaderColor("red");
            }
            */

            selectors.item.each(function(i) {

                min = $(this).offset().top - top_offset; // this.offset().top is the top of each item in the timeline
                max = $(this).height() + $(this).offset().top - top_offset;
                var that = $(this);

                // pos = 1 at the first moment the page scrolls, so a good value to not have opacity would be 50px or so;
                if (i == itemLength - 2 && pos > min + $(this).height() / 2) { // this is the 3rd from the end (itemLength-2)
                    // this gets hit @ the END of the timeline
                    selectors.item.removeClass(selectors.activeClass);
                    selectors.id.css(
                        "background-image",
                        "url(" +
                        selectors.item
                        .last()
                        .find(selectors.img)
                        .attr("srcbg") +
                        ")"
                    );
                    selectors.item.last().addClass(selectors.activeClass);

                    //} else if (pos <= max - 40 && pos >= min) { // the - 40 offset prevents the top "blank" slide from fading back to black on scroll up
                } else if (pos <= max && pos >= min) {
                    $(".timeline").addClass("timeline-ruler"); // show the vertical ruler once we hit the scroll

                    if (i == 0) {
                        $(".timeline").removeClass("timeline-ruler"); // hide the vertical ruler when we're back @ the top
                    }

                    selectors.id.css(
                        "background-image",
                        "url(" +
                        $(this)
                        .find(selectors.img)
                        .attr("srcbg") +
                        ")"
                    );
                    selectors.item.removeClass(selectors.activeClass);
                    $(this).addClass(selectors.activeClass);
                }
            });
        });
    };
})(jQuery);

$("#timeline-1").timeline();